export default "__VITE_ASSET__1aae6ef7__"